module.exports = __webpack_public_path__ + "img/bg_sydzs.eeaece9e.jpg";